import {observer} from "mobx-react";
import {Box, IconButton, Tooltip} from "@mui/material";
import ConditionalComponent from "../Shared/ConditionalComponent";
import GenericCircularLoader from "./GenericCircularLoader";
import CloseIcon from "@mui/icons-material/Close";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import React from "react";
import {guidesUploadStore} from "../../index";

const ProgressCircleWithCancelAndSuccess = observer(({
                                                         value,
                                                         i,
                                                         handleCancelButton,
                                                         hovered,
                                                         file,
                                                     }) => {
    return (

        <Box
            sx={{
                width: `52px`,
                height: '20px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
            }}
        >
            {(value >= 0 && value < 100) && (
                <div key={i}>
                    <Tooltip
                        title="Cancel import"
                        placement="top"
                        arrow
                    >
                        <IconButton
                            onClick={() => handleCancelButton(i)}
                            onMouseEnter={() => {
                                guidesUploadStore.procedureHovered[i] = true

                            }}
                            onMouseLeave={() => {
                                guidesUploadStore.procedureHovered[i] = false

                            }}
                        >

                            <ConditionalComponent if={!hovered}>
                                <GenericCircularLoader value={value}/>
                            </ConditionalComponent>
                            <ConditionalComponent if={hovered}>
                                <CloseIcon
                                    size={18}
                                    sx={{
                                        color: 'var(--leavedeletenew-normal-color)',
                                    }}
                                />
                            </ConditionalComponent>
                        </IconButton>
                    </Tooltip>
                </div>
            )}
            {value === 100 && (
                <CheckCircleIcon
                    size={20}
                    sx={{
                        color: 'var(--onlinesuccess-normal-color)',
                    }}
                />
            )}
            {value === 101 && (
                <div className="text-classicbutton-disabled-color text-[12px]">
                    Canceled
                </div>
            )}
        </Box>

    )
})

export default ProgressCircleWithCancelAndSuccess;